<script>
export default {
  name: 'prevent-leave',
  data () {
    return {
      isSubmitted: false
    }
  },
  methods: {
  },
  created () {
    window.onbeforeunload = () => { return '確定離開編輯頁面?' }
  },
  beforeDestroy () {
    window.onbeforeunload = undefined
  },
  beforeRouteLeave (to, from, next) {
    if (this.isSubmitted) {
      return next(true)
    }
    if (window.confirm('確定離開編輯頁面?')) {
      next(true)
    } else {
      next(false)
    }
  }
}
</script>
